module.exports = __webpack_public_path__ + "img/main-title-bg.b2fe5a9a.jpg";